// src/mocks/data/signage.demo.js

const _base = (typeof window !== 'undefined' ? window.location.origin : '') +
    (process.env.PUBLIC_URL || '') +
    '/demo-media';

const _makeSlide = (id, filename, label, order) => ({
    id,
    campaign_id: 1,
    filename: label,
    src: `${_base}/${filename}`,
    thumbnail: `${_base}/${filename}`,
    type: 'image',
    duration: 5,
    order,
});

const _demoCampaign = {
    id: 1,
    name: 'Campaña 1',
    description: 'Productos destacados — ferretería',
    orientation: 'landscape',
    schedule_days: null,
    is_active: 1,
    schedule: { days: [] },
    created_at: '2026-04-17T11:51:25.246666',
    updated_at: '2026-04-18T10:14:44.870000',
    slides: [
        _makeSlide(1, 'Atronillador.png', 'Atornillador', 1),
        _makeSlide(2, 'Griferia.png', 'Grifería', 2),
        _makeSlide(3, 'Linterna.png', 'Linterna', 3),
        _makeSlide(4, 'Taladro.png', 'Taladro', 4),
        _makeSlide(5, 'TapaAsiento.png', 'Tapa Asiento', 5),
    ],
};

export const campaigns = [_demoCampaign];
export const activeCampaign = _demoCampaign;
export const slides = _demoCampaign.slides;
